/**
 * AppLink — zentraler Wrapper um TanStack <Link>, der automatisch
 * `state.from` auf die aktuelle committed App-Location setzt.
 *
 * Verwendet in allen Komponenten, die App-Navigation durchführen:
 * - MenuItemLink
 * - PropertyEditSubmenu
 * - Normale Links in der App
 *
 * Browser Back/Forward funktioniert weiterhin TanStack-nativ.
 * Der App-Back folgt dem expliziten fachlichen `from`-State.
 */

import { Link, useLocation } from '@tanstack/react-router';
import { withFromState } from '~/services/AppBackService';

/**
 * AppLink — injectiert automatisch state.from in jeden Link.
 * Usage: <AppLink to="/somewhere" params={{...}}>Text</AppLink>
 *
 * Typen werden via any gecastet, weil TanStack Router v1 stark typisierte
 * generische Parameter für to/params hat, die wir hier nicht auflösen können.
 * Das ist konsistent mit MenuItemLink.
 */
export function AppLink(props: Record<string, any>): React.ReactElement {
  const location = useLocation();
  const enhancedProps = withFromState(location, props);
  return <Link {...(enhancedProps as any)} />;
}
